import { Turbo } from '@hotwired/turbo-rails'
import application from 'lib/stimulus'

// Clone cached snapshots before rendering so a cached body can never become the live document.body.
// Reusing that same snapshot can otherwise detach the live body during a later history restoration.
// @see https://github.com/hotwired/turbo/pull/1559
const getCachedSnapshotForLocation = Turbo.session.view.getCachedSnapshotForLocation
Turbo.session.view.getCachedSnapshotForLocation = function(location) {
  return getCachedSnapshotForLocation.call(this, location)?.clone()
}

// Ensure that the responseHTML is loaded before the fetchRequest is declared finished
// @see https://github.com/hotwired/turbo/pull/1377
const originalReceive = Turbo.FetchRequest.prototype.receive
Turbo.FetchRequest.prototype.receive = async function(response) {
  let fetchResponse = await originalReceive.call(this, response)
  await fetchResponse.responseHTML
  return fetchResponse
}

// Ensure that the correct Turbo-Frame is passed when using target=_top
// @see https://github.com/hotwired/turbo/issues/1349
const originalPrepareRequest = Turbo.session.linkPrefetchObserver.prepareRequest
Turbo.session.linkPrefetchObserver.prepareRequest = function(request) {
  originalPrepareRequest.call(this, request)
  if (request.headers['Turbo-Frame'] === '_self') {
    request.headers['Turbo-Frame'] = request.target.closest('turbo-frame')?.id
  }
}

// Apply aria-busy on submitters to indicate that the form is being submitted.
// This lets us target styling to the submitter.
const { beforeSubmit, afterSubmit } = Turbo.config.forms.submitter
Turbo.config.forms.submitter = {
  beforeSubmit: submitter => {
    submitter.setAttribute('aria-busy', 'true')
    beforeSubmit(submitter)
  },
  afterSubmit: submitter => {
    submitter.removeAttribute('aria-busy')
    afterSubmit(submitter)
  }
}

// Confirm form submissions (data-turbo-confirm) with the styled Ui::Confirm
// dialog rendered in shared/_overlays, falling back to the native confirm.
Turbo.config.forms.confirm = (message) => {
  const dialog = document.getElementById('turbo_confirm')
  const controller = dialog && application.getControllerForElementAndIdentifier(dialog, 'confirm')

  if (controller) {
    return controller.confirm(message)
  } else {
    return Promise.resolve(window.confirm(message))
  }
}

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target, { action: 'replace' });
};

document.addEventListener('turbo:before-morph-element', event => {
  const { currentElement, newElement } = event.detail
  if (currentElement._x_dataStack) { window.Alpine.clone(currentElement, newElement) }
});
